// @ts-nocheck
import React from 'react';
import Text from 'crehana-ui/Text';
import StringParser from 'Shared/StringParser';

const Legals = ({ legalsCopy }) => {
  return (
    <div className="mt-48 sm:mt-80">
      <Text className="mb-12 tw-font-semibold" type="legals" as="p" color="white">
        Términos y condiciones de la promoción
      </Text>
      <StringParser string={legalsCopy} emails>
        {({ string: parsedString }) => (
          <Text type="legals" as="p" color="gray-dark">
            {parsedString}
          </Text>
        )}
      </StringParser>
    </div>
  );
};

export default Legals;
